import { z } from "zod";

const dateTransform = z.preprocess(
  (val) => (val ? new Date(val as string) : null),
  z.date().nullable()
);

export const PhotoSchema = z.object({
  photoid: z.number(),
  pjobid: z.number().nullable(),
  pwoid: z.number().nullable(),
  pcid: z.number().nullable(),
  pcinid: z.number().nullable(),
  psectiontrackingid: z.string().nullable(),
  pwotype: z.string().nullable(),
  puser: z.string().nullable(),
  photoname: z.string().nullable(),
  photoname_s3: z.string().nullable(),
  photoext: z.string().nullable(),
  photocat: z.string().nullable(),
  photodts: dateTransform,
  photolabel: z.string().nullable(),
  phototags: z.string().nullable(),
  photoorder: z.number().nullable().default(0),
  photoidcc: z.string().nullable(),
  photodtscc: z.string().nullable(),
  photoreq: z.string().nullable(),
  photonotes: z.string().nullable(),
  
  // Non-database fields
  isUploaded: z.boolean().optional(),
  presignedURLs: z.object({
    image: z.object({
      key: z.string(),
      getURL: z.string(),
      putURL: z.string()
    }),
    thumbnail: z.object({
      key: z.string(),
      getURL: z.string(),
      putURL: z.string()
    })
  }).optional()
});

export type Photo = z.infer<typeof PhotoSchema>; 